import React, { type FunctionComponent } from 'react'
import { MenuItem, OutlinedInput } from '@mui/material'
import { Layers } from '@mui/icons-material'
import { SelectPlaceholder, SelectedText, SmallSelect } from './sorty-by-select.styles'

export const SORT_OPTIONS = {
	NAME: 'Name',
	LAST_UPDATE: 'Last Update',
	OLDEST_UPDATE: 'Oldest Update',
	STATUS: 'Status',
}

const OPTIONS = [
	SORT_OPTIONS.NAME,
	SORT_OPTIONS.LAST_UPDATE,
	SORT_OPTIONS.OLDEST_UPDATE,
	SORT_OPTIONS.STATUS,
]

type SortBySelectProps = {
	value: string | null,
	onChange: ( value: string | null ) => void,
}

export const SortBySelect: FunctionComponent<SortBySelectProps> = ( { value, onChange } ) => {
	return (
		<SmallSelect
			displayEmpty
			value={value ?? ''}
			onChange={( event ) => onChange( event.target.value as string )}
			input={<OutlinedInput />}
			renderValue={( selected ) => {
				if ( !selected ) {
					return <SelectPlaceholder><Layers fontSize="small" />Sort By</SelectPlaceholder>
				}

				return <SelectedText>{selected as React.ReactNode}</SelectedText>
			}}
			inputProps={{ 'aria-label': 'Without label' }}
		>
			{OPTIONS.map( ( option ) => (
				<MenuItem
					key={option}
					value={option}
				>
					{option}
				</MenuItem>
			) )}
		</SmallSelect>
	)
}
